import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-point2",
  "use": "icon-point2-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-point2\"><defs><style>#icon-point2 .cls-1{fill:#30aa9f;}</style></defs><polygon class=\"cls-1\" points=\"103.579 124.819 64 100.959 24.421 124.819 34.9 79.814 0 49.546 46.034 45.614 64 3.181 81.966 45.614 128 49.546 93.1 79.814 103.579 124.819\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol